import {pxToRem} from '../../../../utills/pxToRem'

export const HeroBannerStyle = {
    '#homepage-slides': {
        margin: 0,
        position: 'relative',
        listStyle: 'none',
        paddingInlineStart: 0,
        display: 'block',
        '.slick-slider svg': {
            backgroundColor: 'cav_red',
            color: 'white',
            zIndex: 9,
            width: pxToRem(31),
            border: '2px solid cav_red'
        },
        '.slick-slider svg:focus': {
            outline: '2px solid cav_blue',
            outlineOffset: '-2px'
        },
        '.slick-slider .slick-dots': {
            position: 'absolue',
            bottom: pxToRem(15),
            'li button:before': {
                borderRadius: '100%',
                border: '2px solid white',
                color: 'transparent'
            },
            'li button::before': {
                position: 'absolute',
                top: '0',
                left: '0',
                width: pxToRem(15),
                height: pxToRem(15),
                textAlign: 'center',
                margin: '0 5px',
                opacity: '1'
            },
            'li.slick-active button:before': {
                backgroundColor: 'white',
                color: 'white'
            }
        },

        '.slide': {
            position: 'relative',
            width: '100%',
            aspectRatio: '50/21',
            '.custom-container': {
                paddingLeft: pxToRem(100),
                '@media (max-width: 1024px)': {
                    paddingLeft: pxToRem(27)
                }
            },
            '.custom-title, h1': {
                color: 'white',
                fontFamily: 'Montserrat',
                fontSize: pxToRem(30),
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: 'normal',
                letterSpacing: pxToRem(4.5),
                textTransform: 'uppercase',
                paddingBottom: pxToRem(20),
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'left',

                '@media (max-width: 640px)': {
                    fontSize: pxToRem(22),
                    letterSpacing: pxToRem(3.3),
                    paddingBottom: pxToRem(15),
                    flexDirection: 'column',
                    textAlign: 'center'
                }
            },

            '.custom-links': {
                display: 'flex',
                justifyContent: 'start',
                flexDirection: 'row',
                gap: pxToRem(20),

                a: {
                    color: 'cav_red',
                    textAlign: 'center',
                    fontFamily: 'Montserrat',
                    fontSize: pxToRem(14),
                    fontStyle: 'normal',
                    fontWeight: 700,
                    letterSpacing: pxToRem(1.68),
                    textTransform: 'uppercase',
                    backgroundColor: 'white',
                    padding: `12px 20px`,
                    width: pxToRem(295),
                    transition: 'all 0.3s ease',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    lineHeight: pxToRem(13.5),

                    '&:hover': {
                        background: 'cav_red',
                        color: 'white',
                        transform: 'scale(1.05)'
                    },

                    '@media (max-width: 640px)': {
                        width: pxToRem(260),
                        fontSize: pxToRem(12),
                        lineHeight: pxToRem(13.5),
                        letterSpacing: pxToRem(1.44)
                    }
                },
                '@media (max-width: 640px)': {
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: pxToRem(10)
                }
            },
            '.custom-content': {
                color: 'white',
                fontFamily: 'Montserrat',
                fontSize: pxToRem(16),
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: 'normal',
                letterSpacing: pxToRem(1.28),
                paddingBottom: pxToRem(40),
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'left',
                '@media (max-width: 640px)': {
                    // mobile
                    fontSize: pxToRem(14),
                    letterSpacing: pxToRem(1.12),
                    paddingBottom: pxToRem(30),
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            },

            '.hero-banner-container': {
                position: 'absolute',
                bottom: pxToRem(96),
                left: 0,
                width: '100%',
                textAlign: 'center',
                zIndex: 1,
                display: 'flex',
                justifyContent: 'start',
                paddingLeft: pxToRem(100),

                '@media (max-width: 1024px)': {
                    // Tab
                    paddingLeft: pxToRem(27)
                },
                '@media (max-width: 640px)': {
                    // mobile
                    justifyContent: 'center',
                    paddingLeft: 0
                }
            },

            '.hero-banner-main-heading': {
                fontSize: pxToRem(80),
                fontWeight: 'bold',
                textAlign: 'center',
                color: 'white',
                textTransform: 'uppercase',
                marginBottom: pxToRem(60),
                letterSpacing: pxToRem(4.5),
                fontFamily: 'Montserrat',
                lineHeight: 'normal',
                '@media (max-width: 1024px)': {
                    fontSize: pxToRem(26),
                    marginBottom: '0',
                    letterSpacing: pxToRem(3.3)
                }
            },

            'img, picture, video': {
                maxWidth: '100%',
                width: '100%'
            },
            '@media (max-width: 1024px)': {
                aspectRatio: '16/15'
            },
            '@media (max-width: 640px)': {
                aspectRatio: '375/669'
            }
        },
        'button[type="button"]': {
            zIndex: 9,
            margin: pxToRem(8),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        '.slick-prev': {
            left: `0`,
            height: pxToRem(35),
            width: pxToRem(40),
            color: 'white',
            border: `${pxToRem(2)} solid`,
            borderColor: 'cav_red'
        },
        '.slick-next': {
            right: `0`,
            height: pxToRem(35),
            width: pxToRem(40),
            color: 'white',
            border: `${pxToRem(2)} solid`,
            borderColor: 'cav_red'
        },
        '.slick-next:hover, .slick-prev:hover': {
            backgroundColor: 'cav_red'
        }
    }
}
